import React from 'react';
import { Box, Typography } from '@mui/material';
import { PackageName } from '../../../config/package';
import { PackageDisplay } from './PackageDisplay';

export const Versions: React.FC = () => {
  const packages = [
    PackageName.Splice,
    PackageName.CredentialApp,
    PackageName.RegistryApp,
    PackageName.CollateralApp,
    PackageName.CommercialAgreement,
  ];
  const displayed = packages.map((p) => (
    <Box sx={{ mb: 3 }} key={p}>
      <Typography
        sx={{ textTransform: 'capitalize', mb: 1 }}
        color="primary"
        variant="h4"
        fontWeight="bold"
      >
        {p}
      </Typography>
      <PackageDisplay packageName={p} />
    </Box>
  ));
  return <Box sx={{ maxWidth: '800px' }}>{displayed}</Box>;
};
